import React from 'react';

const HealthCheck = () => {
  return (
    <div>
      <h2>Health Check</h2>
      <p>Application is healthy and running.</p>
    </div>
  );
};

export default HealthCheck;
